export default __webpack_public_path__ + "static/media/spring.4075d0e0.svg";